const state = {
  parc: {},
  eoliennes: [],
  postesLivraison: [],
  gunParcData: {}
};

const mutations = {
  SET_PARC(state, parc) {
    state.parc = parc;
  },
  SET_EOLIENNES(state, eoliennes) {
    state.eoliennes = eoliennes;
  },
  SET_POSTES_LIVRAISON(state, postesLivraison) {
    state.postesLivraison = postesLivraison;
  },
  SET_GUN_PARC_DATA(state, gunParcData) {
    state.gunParcData = gunParcData;
  }
};

const actions = {
  saveParc({ commit }, parc) {
    commit("SET_PARC", parc);
  },
  saveSelectedParcProfile({ commit }, selectedParcProfile) {
    commit("SET_PARC", selectedParcProfile.parc);
    commit("SET_EOLIENNES", selectedParcProfile.eoliennes);
    commit("SET_POSTES_LIVRAISON", selectedParcProfile.postesLivraison);
  },
  clearSelectedParcProfile({ commit }) {
    commit("SET_PARC", {});
    commit("SET_EOLIENNES", []);
    commit("SET_POSTES_LIVRAISON", []);
  },
  saveGunParcData({ commit }, gunParcData) {
    commit("SET_GUN_PARC_DATA", gunParcData);
  },
};

const getters = {
  getSelectedParcProfile(state) {
    return {
      parc: state.parc,
      eoliennes: state.eoliennes,
      postesLivraison: state.postesLivraison
    };
  },
  parc(state) {
    return state.parc;
  },
  eoliennes(state) {
    return state.eoliennes;
  },
  postesLivraison(state) {
    return state.postesLivraison;
  },
  epsg(state) {
    return state.parc.projection.epsg;
  },
  isParc(state) {
    return (
      state.parc != null &&
      !(
        Object.keys(state.parc).length === 0 &&
        state.parc.constructor === Object
      )
    );
  },
  isEoliennes(state) {
    return state.eoliennes.length > 0;
  },
  isPostesLivraison(state) {
    return state.postesLivraison.length > 0;
  },
  isRejet(state) {
    return state.parc.statutParc
      ? state.parc.statutParc.libelle == "Rejeté"
      : null;
  },
  isRefus(state) {
    return state.parc.statutParc
      ? state.parc.statutParc.libelle == "Refusé"
      : null;
  },
  isCessationActivite(state) {
    return state.parc.statutParc
      ? state.parc.statutParc.libelle == "En cessation d'activité"
      : null;
  },
  isAutorisation(state) {
    return state.parc.statutAdministratif != null
      ? state.parc.statutAdministratif.libelle == "Autorisation"
      : null;
  },
  isDeclaration(state) {
    return state.parc.statutAdministratif
      ? state.parc.statutAdministratif.libelle == "Déclaration"
      : null;
  },
  isLock(state, store) {
    // Vérification du lock
    return state.parc.dateVerrou
      ? store.user.email != state.parc.mailVerrou &&
          new Date(state.parc.dateVerrou) > new Date(new Date().toDateString())
      : false;
  },
  isBrouillon(state) {
    return state.parc.statutSaisie
      ? state.parc.statutSaisie.libelle == "Brouillon"
      : false;
  },
  isPublie(state) {
    return state.parc.statutSaisie
      ? state.parc.statutSaisie.libelle == "Publié"
      : false;
  },
  isAnnule(state) {
    return state.parc.statutSaisie
      ? state.parc.statutSaisie.libelle == "Annulé"
      : false;
  },
  isDepublie(state) {
    return state.parc.statutSaisie
      ? state.parc.statutSaisie.libelle == "Dépublié"
      : false;
  },
  isSaisieNonDemarree(state) {
    return state.parc.statutSaisie
      ? state.parc.statutSaisie.libelle == "Saisie non démarrée"
      : true;
  },
  isRenouvellement(state) {
    return state.parc.renouvellement;
  },
  isRenouvellementNotable(state) {
    return state.parc.renouvellementNotable;
  },
  isRenouvellementSubstantiel(state) {
    return state.parc.renouvellementSubstantiel;
  },
  isInventaireCommunes(state) {
    return (
      state.parc.inventaireCommunes != null &&
      state.parc.inventaireCommunes.length > 0
    );
  },
  isEoliennesDeclared(state) {
    return state.parc.nombreAerogenerateur > 0;
  },
  isPostesLivraisonDeclared(state) {
    return state.parc.nombrePosteLivraison > 0;
  },
  isEolienneDeclarationValid(state) {
    return (
      state.parc.nombreAerogenerateur > 0 &&
      state.parc.nombreAerogenerateur == state.eoliennes.length
    );
  },
  isPosteLivraisonDeclarationValid(state) {
    return (
      state.parc.nombrePosteLivraison == state.postesLivraison.length
    );
  },
  isPosteLivraisonModificationValid(state) {
    return (
      state.parc.nombrePosteLivraison >= state.postesLivraison.length
    );
  },
  isAnteDebutConstruction(state) {
    return state.parc.dateDebutConstruction
      ? new Date() < new Date(state.parc.dateDebutConstruction)
      : true;
  },
  eoliennesGeomList(state) {
    const eoliennesGeomList = [];
    state.eoliennes.forEach(eolienne => {
      if (eolienne.geomWgs84) {
        eoliennesGeomList.push({
          id: eolienne.id,
          latLng: [eolienne.geomWgs84.coordinates[1], eolienne.geomWgs84.coordinates[0]]
        });
      }
    });
    return eoliennesGeomList;
  },
  postesLivraisonGeomList(state) {
    const postesLivraisonGeomList = [];
    state.postesLivraison.forEach(poste => {
      if (poste.geomWgs84) {
        postesLivraisonGeomList.push({
          id: poste.id,
          latLong: [poste.geomWgs84.coordinates[1], poste.geomWgs84.coordinates[0]]
        });
      }
    });
    return postesLivraisonGeomList;
  },
  eoliennesConstructeurs(state) {
    const eoliennesConstructeurs = new Set();
    state.eoliennes.forEach(eolienne => {
      if (eolienne.constructeur) {
        eoliennesConstructeurs.add(eolienne.constructeur.nom);
      } else if (eolienne.constructeurAutre) {
        eoliennesConstructeurs.add(eolienne.constructeurAutre);
      }
    });
    return [...eoliennesConstructeurs];
  },
  eoliennesMaxHauteur(state) {
    const eolienneHauteurTotale = [];
    state.eoliennes.forEach(eolienne => {
      if (eolienne.hauteurTotale) {
        eolienneHauteurTotale.push(eolienne.hauteurTotale);
      }
    });
    return eolienneHauteurTotale.length > 1
      ? Math.max(...eolienneHauteurTotale)
      : null;
  },
  isAdministrateurRegionParc(state, getters) {
    let parcRegions = [];
    if (getters.isInventaireCommunes) {
      parcRegions = state.parc.inventaireCommunes.map(inventaireCommune => {
        return inventaireCommune.codeRegion;
      });
    }
    return getters.administrateurRegion
      ? parcRegions.includes(getters.administrateurRegion)
      : false;
  },
  eolienneNextId(state) {
    return elementNextId(state.eoliennes, '_E');
  },
  postesLivraisonNextId(state) {
    return elementNextId(state.postesLivraison, '_PL');
  },
  gunParcData(state) {
    return state.gunParcData;
  },
  isGunAndOreolConsistent(state) {
    const gunParcData = state.gunParcData;
    const parc = state.parc;

    if (gunParcData && parc) {
      return gunParcData.raisonSociale == parc.nomUsuel;
    }
    return false;
  }
};

function elementNextId(elements, splitString) {
  const elementsIds = [];
  elements.forEach(element => {
    let elementId = element.id.split(splitString);
    elementId = parseInt(elementId[elementId.length - 1]);
    elementsIds.push(elementId);
  });

  let nextId = 1;
  for (let i = 0 ; i < elementsIds.length; i++) {
    if (elementsIds[i] == nextId && i == elementsIds.length - 1)
      return nextId + 1;
    else if (elementsIds[i] == nextId)
      nextId++;
    else
      return nextId;
  }

  return nextId;
}

export default {
  state,
  mutations,
  actions,
  getters
};
